/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateCustomerConfigurationRequest } from '../../models/create-customer-configuration-request';
import { CreateCustomerConfigurationResponse } from '../../models/create-customer-configuration-response';

export interface Create_1$Params {
  
    /**
     * Customer configuration to be created.
     */
    body: CreateCustomerConfigurationRequest
}

export function create_1(http: HttpClient, rootUrl: string, params: Create_1$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateCustomerConfigurationResponse>> {
  const rb = new RequestBuilder(rootUrl, create_1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateCustomerConfigurationResponse>;
    })
  );
}

create_1.PATH = '/v1/organizations/configuration/customer';
